import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button, SpinnerOverlay, TextArea } from '@components/common';

import useQueryNetworkElementNote from '@hooks/networkElementConfigurations/useQueryNetworkElementNote';

import { IChangeMonitoring } from '@interfaces/networkElementConfigurations/networkElementConfigurations';

import { EButtonType } from '@enums/common';

import { MAX_NOTES_LENGTH } from '../constants';

import styles from './NetworkConfigurationsNotes.module.scss';

interface INetworkConfigurationsNotesProps {
	isEditMode: boolean;
	config: IChangeMonitoring | null;
	defaultNoteText?: string;
	onClose: () => void;
	onSubmit?: (note: string) => void;
	setIsDirtyForm?: (isDirtyForm: boolean) => void;
}

const NetworkConfigurationsNotes = ({
	isEditMode,
	config,
	onClose,
	setIsDirtyForm,
	onSubmit,
	defaultNoteText = '',
}: INetworkConfigurationsNotesProps) => {
	const [noteText, setNoteText] = useState<string>(defaultNoteText);

	const { groupNumber = NaN } = config || {};

	const { id: networkElementId } = useParams();

	const { networkElementNote, isLoadingNetworkElementNote } = useQueryNetworkElementNote({
		groupNumber,
		networkElementId: networkElementId || '',
	});

	useEffect(() => {
		if (networkElementNote) {
			setNoteText(networkElementNote);
		}
	}, [networkElementNote]);

	const onChange = (value: string) => {
		setNoteText(value);

		if (setIsDirtyForm) {
			setIsDirtyForm(true);
		}
	};

	const handleSubmit = () => {
		if (onSubmit) {
			onSubmit(noteText);
		}
	};

	return (
		<div className={styles.wrapper}>
			{isLoadingNetworkElementNote && <SpinnerOverlay />}
			<TextArea
				isMaxLengthCounter={isEditMode}
				isNotResizable
				maxLength={isEditMode ? MAX_NOTES_LENGTH : undefined}
				name='notes'
				onChange={onChange}
				readonly={!isEditMode}
				textAreaClassName={styles.textArea}
				value={noteText}
				valueLength={noteText?.length}
			/>
			<div className={styles.buttonsWrapper}>
				<Button
					large
					onClick={onClose}
					text='Cancel'
					type={!isEditMode ? EButtonType.submit : undefined}
				/>
				{isEditMode && (
					<Button
						disabled={noteText?.length === 0}
						large
						onClick={handleSubmit}
						text='Save'
						type={EButtonType.submit}
					/>
				)}
			</div>
		</div>
	);
};

export default NetworkConfigurationsNotes;
